import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';

export const moduleListRoute: RouteConfig = {
  path: 'module',
  name: 'moduleList',
  component: () => import(/* webpackChunkName: "ModuleList" */ '@/views/mainRoute/module/List.vue'),
  meta: {
    breadcrumb: {
      title: 'Moduły',
      name: 'moduleList'
    },
    config: {
      title: 'Moduły',
      name: 'moduleList',
      icon: 'fa-cubes',
      permissions: ['MODULE.LIST'],
      group: 'Konfiguracja wzorów'
    }
  },
  beforeEnter: (to, from, next) => {
    store
      .dispatch('module/list')
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.MODULE_CANNOT_LIST }));
  }
};
